






















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Employee, employeeAdminApis, InvalidParam, Department } from '../../api';
import DepartmentSelect from './DepartmentSelect.vue';

@Component({ components: { DepartmentSelect } })
export default class EmployeeEditDialog extends Vue {
  readonly rules = {
    department_ids: { required: true, message: '请选择部门' },
    username: { required: true, message: '请输入用户名' },
    display_name: { required: true, message: '请输入姓名' },
    email: { required: true, message: '请输入邮箱' }
  };
  readonly labelWidth = '6rem';

  dialogVisible = false;
  employee: Employee | null = null;
  errors: any = {};
  resolve: ((e: Employee) => void) | null = null;
  loading = false;
  disabled = false;

  show(employee: Employee | null) {
    if (employee) {
      this.employee = JSON.parse(JSON.stringify(employee));
      if (
        this.employee &&
        this.employee.departments &&
        this.employee.departments.length > 0 &&
        this.employee.departments[0].length > 0
      ) {
        (this.employee as Employee).department_ids = [this.employee.departments[0][0].id];
      }
    } else {
      this.employee = {} as Employee;
    }
    this.dialogVisible = true;
    return new Promise<Employee>(resolve => (this.resolve = resolve));
  }

  get depError() {
    if (this.errors.department_ids) {
      return this.errors.department_ids.self;
    }
    return null;
  }

  async save() {
    if (this.employee) {
      this.errors = {};
      this.loading = true;
      this.disabled = true;
      try {
        const e = await employeeAdminApis.save(this.employee);
        if (this.resolve) {
          Object.assign(this.employee, e);
          this.resolve(this.employee);
          this.resolve = null;
        }
        this.$notify.success(`保存用户[${e.display_name}]成功`);
        this.loading = false;
        this.disabled = false;
        this.dialogVisible = false;
      } catch (e) {
        if (e instanceof InvalidParam) {
          this.errors = e.params;
        } else {
          this.$notify.error(e.message);
        }
      } finally {
        this.loading = false;
        this.disabled = false;
      }
    }
  }

  async submitForm(formName: any) {
    (this.$refs[formName] as any).validate((valid: boolean) => {
      if (valid) {
        this.save();
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  getDepartment() {
    if (this.employee) {
      if (this.employee.departments) {
        if (this.employee.departments.length > 0) {
          return this.employee.departments[0][this.employee.departments[0].length - 1];
        }
      }
    }
    return null;
  }

  selectDepartment(d: Department) {
    if (this.employee) {
      this.employee.departments = [[d]];
      this.employee.department_ids = [d.id];
    }
  }

  onClosed() {
    this.resolve = null;
    this.employee = null;
    this.errors = {};
  }

  deleteAccountLock(employee_id: number) {
    employeeAdminApis
      .delete_account_lock(employee_id)
      .then(() => {
        this.$notify.success('解除锁定成功');
      })
      .catch(e => {
        this.$notify.error(e.toString());
      });
  }
}
